export type RuntimeConfigKey =
  | 'REACT_APP_SERVICE_NAME'
  | 'REACT_APP_SECRET_KEY'
  | 'REACT_APP_BASE_API_URL'
  | 'REACT_APP_API_URL'
  | 'REACT_APP_THEME_API_URL'
  | 'REACT_APP_BASE_URL'
  | 'REACT_APP_PRIVACY_POLICY_GUID'

export function getRuntimeConfigValue(key: RuntimeConfigKey, fallback?: string): string | undefined {
  const runtimeValue = typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__?.[key] : undefined

  return runtimeValue || fallback
}
